import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

import BasicModalContainer from '../../../common/components/basicmodal/BasicModalContainer';
import ModalHeader from '../../../common/components/basicmodal/ModalHeader';
import ModalBody from '../../../common/components/basicmodal/ModalBody';
import ModalFooter from '../../../common/components/basicmodal/ModalFooter';

import { communicationModalStyle } from './styles/CommunicationModalStyle';
import { BOHTlbRadio } from '../../../common/components/bohtoolbar';

interface CommunicationModalProps {
  isModalVisible: boolean;
  closeModal: () => void;
  isDelivered?: boolean;
  onSend: (method: string, type: string, location?: { latitude: number; longitude: number }) => void;
}

const CommunicationModal = ({
  isModalVisible,
  closeModal,
  isDelivered = false,
  onSend,
}: CommunicationModalProps) => {
  const [selectedOption, setSelectedOption] = useState('email');
  const [selectedType, setSelectedType] = useState('order_details');
  const [location, setLocation] = useState(null);

  // Default to order_details for new orders, confirmation for delivered orders
  useEffect(() => {
    if (!isModalVisible) return;
    setSelectedType(isDelivered ? 'delivery' : 'order_details');
  }, [isModalVisible, isDelivered]);

  // useEffect(() => {
  //   if (isModalVisible) {
  //     setSelectedOption('email'); // Reset to default when modal opens
  //     // Get location when modal opens
  //     if ("geolocation" in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           setLocation({
  //             latitude: position.coords.latitude,
  //             longitude: position.coords.longitude
  //           });
  //         },
  //         (error) => {
  //           console.error("Error getting location:", error);
  //         }
  //       );
  //     }
  //   }
  // }, [isModalVisible]);

  const handleSend = () => {
    // Include location data in the send operation if needed
    onSend(selectedOption, selectedType, location);
    closeModal();
  };

  const closeModalHandler = () => {
    closeModal();
  };

  const RadioButton = ({ value, selected, onPress, label }) => (
    <TouchableOpacity 
      style={styles.radioContainer} 
      onPress={() => onPress(value)}
    >
      <View style={styles.radioButton}>
        {selected && <View style={styles.radioButtonInner} />}
      </View>
      <Text style={[styles.radioLabel, selected && styles.radioLabelSelected]}>
        {label}
      </Text>
    </TouchableOpacity>
  );

  return isModalVisible ? (
    <View style={{ position: 'absolute', width: '100%', height: '100%' }}>
      <BasicModalContainer>
        <ModalHeader
          label={'Send Reservation Details'}
          closeModal={closeModalHandler}
        />
        <ModalBody style={{ zIndex: 10 }}>
          <View>
            <Text style={styles.subtitle}>
              Choose how to send it to the customer:
            </Text>

            <View>
              <BOHTlbRadio
                style={{marginHorizontal: 0}}
                label='Send SMS'
                onPress={()=>setSelectedOption('sms')}
                RadioButtonProps={{
                  value: 'sms',
                  status: selectedOption == 'sms'? 'checked': 'unchecked',
                }}
              />
              <BOHTlbRadio
                style={{marginHorizontal: 0}}
                label='Send Email'
                onPress={()=>setSelectedOption('email')}
                RadioButtonProps={{
                  value: 'email',
                  status: selectedOption == 'email'? 'checked': 'unchecked',
                }}
              />
              <BOHTlbRadio
                style={{marginHorizontal: 0}}
                label='Both'
                onPress={()=>setSelectedOption('both')}
                RadioButtonProps={{
                  value: 'both',
                  status: selectedOption == 'both'? 'checked': 'unchecked',
                }}
              />
            </View>

            <Text style={[styles.subtitle, { marginTop: 12 }]}>
              Choose what to send to the customer:
            </Text>

            <View>
              <BOHTlbRadio
                style={{marginHorizontal: 0}}
                label='Confirmation'
                onPress={()=>setSelectedType('confirmation')}
                RadioButtonProps={{
                  value: 'confirmation',
                  status: selectedType == 'confirmation'? 'checked': 'unchecked',
                }}
              />
              <Text style={styles.descriptionText}>
                Send reservation confirmation with booking details and pricing
              </Text>

              <BOHTlbRadio
                style={{marginHorizontal: 0}}
                label='Order Details'
                onPress={()=>setSelectedType('order_details')}
                RadioButtonProps={{
                  value: 'order_details',
                  status: selectedType == 'order_details'? 'checked': 'unchecked',
                }}
              />
              <Text style={styles.descriptionText}>
                Send complete order summary with items, dates, and pricing
              </Text>

              {isDelivered ? (
                <>
                  <BOHTlbRadio
                    style={{marginHorizontal: 0}}
                    label='Delivery'
                    onPress={()=>setSelectedType('delivery')}
                    RadioButtonProps={{
                      value: 'delivery',
                      status: selectedType == 'delivery'? 'checked': 'unchecked',
                    }}
                  />
                  <Text style={styles.descriptionText}>
                    Send delivery/pickup instructions with location and lock details
                  </Text>
                </>
              ) : (
                <Text style={styles.hintText}>
                  Delivery details can be sent once the order is delivered.
                </Text>
              )}
            </View>
          </View>
        </ModalBody>
        <ModalFooter>
          <View style={styles.footerContainer}>
            <TouchableOpacity onPress={closeModalHandler}>
              <Text style={styles.addButton}>Cancel</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handleSend}>
              <Text style={styles.addButton}>Send</Text>
            </TouchableOpacity>
          </View>
        </ModalFooter>
      </BasicModalContainer>
    </View>
  ) : null;
};

const styles = communicationModalStyle;

export default CommunicationModal;